import { render, staticRenderFns } from "./printGoodsLabels.vue?vue&type=template&id=2de928ff&scoped=true&"
import script from "./printGoodsLabels.vue?vue&type=script&lang=js&"
export * from "./printGoodsLabels.vue?vue&type=script&lang=js&"
import style0 from "./printGoodsLabels.vue?vue&type=style&index=0&id=2de928ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de928ff",
  null
  
)

component.options.__file = "printGoodsLabels.vue"
export default component.exports